import React from 'react'
import { app } from "router/routes";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { NewsletterRM } from 'models/RM';
import { newsletterStatuses } from 'keys'
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editNewsletterFetch } from 'store/middlewares/newsletter.crud';
import constants from './constants';
import { toast } from 'react-toastify';
import { toastConfig } from 'config';
import { useDispatch } from 'react-redux';
import { change, isValid, submit } from 'redux-form';

const useSubmitBtns = () => {
    const formValues = useSelector(state => state.form.newsletter?.values)
    const isFormValid = useSelector(state => isValid(constants.formname)(state));
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { mutateAsync: editNewsletter, isPending } = useMutation({
        mutationFn: editNewsletterFetch,
        onSuccess: () => {
            toast("העדכון עבר בהצלחה", toastConfig)
        }
    })

    const cancel = useCallback(() => {
        navigate(-1)
    }, [])

    const handleSubmit = useCallback(() => {
        if (!isFormValid) {
            dispatch(submit(constants.formname)) // Trigger validation for the current step
            return false
        }

        return isFormValid
    }, [isFormValid])

    const saveAsDraft = useCallback(async (contentImages) => {
        const submit = handleSubmit()
        if (submit) {
            const nNewsletter = new NewsletterRM({ ...formValues, images: contentImages, status: newsletterStatuses.DRAFT })
            const { data } = await editNewsletter(nNewsletter)
            dispatch(change("newsletter", "id", formValues.id || data.id))
        }
    }, [formValues, isFormValid])

    const publish = useCallback(async (contentImages) => {
        const submit = handleSubmit()
        if (submit) {
            const nNewsletter = new NewsletterRM({ ...formValues, images: contentImages, status: newsletterStatuses.PUBLISHED })
            await editNewsletter(nNewsletter)
            navigate(app.newsletters)
        }
    }, [formValues, isFormValid])

    const submitBtns = React.useMemo(
        () => [
            {
                label: "ביטול",
                action: cancel,
                color: "thirdly4",
                disabled: false
            },
            {
                label: "שמור כטיוטה",
                color: "thirdly4",
                action: saveAsDraft,
                loading: isPending,
                disabled: false
            },
            {
                label: "פרסם",
                color: "secondary",
                action: publish,
                loading: isPending
            }
        ],
        [formValues, isFormValid]
    );

    return submitBtns
}

export default useSubmitBtns